/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Checkbox,
  FormControlLabel,
  TextField,
  RadioGroup,
} from '@material-ui/core';
import { forIn, groupBy } from 'lodash';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { AllManufactureTableHead } from './TableHead';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import PaginationBox from './PaginationBox';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  getMFGGrid,
  getNDCGrid,
  dispatchStatus,
  getMFGGridExportAll,
  getNDCGridExportAll,
  setPaginationIndex,
} from '../Store/action';
import { exportAllPDF } from '../../../../SharedModules/pdfExport/exportAll';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import { handleScrollToEvent } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { comparatorQtrNew } from '../../../../SharedModules/utilities/utilities';
// import { getRequiredColumn } from './TableHead';
const DisplayDisputeActivity = () => {
  const {
    displayObj: {
      disputeCodeOption: getDisputeCode,
      rebateProgramName: getRebateProgramName,
      selectByValue: getSelectedOptionList,
      allManufacturer: manufactureName,
      manufactureWithIds: manufactureID,
      gridMFG: mfgGridList,
      gridNDC: ndcGridList,
      drugData: drugDataList,
      open,
      closed,
      countValue,
      labelerSelectedRow,
    },

    exportAllData,
  } = useSelector((state) => state?.sharedState?.DisputeActivityReducer);
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const [checkboxValues, setCheckboxValues] = React.useState({
    open: open,
    closed: closed,
  });
  const dispatch = useDispatch();
  const [mfgGrid, setMfgGrid] = React.useState([]);
  const [ndcGrid, setNdcGrid] = React.useState([]);
  const [columnApi, setColumnApi] = React.useState(null);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [filteredRows, setFilteredRow] = React.useState([]);
  const [isExportAllClick, setIsExportAllClick] = React.useState(false);
  const [error, setError] = React.useState([]);
  const paginationLength =
    getSelectedOptionList == 'NDC'
      ? drugDataList?.length
      : manufactureID?.length;
  const [count, setCount] = React.useState(countValue);
  const [paginationArray, setPaginationArray] = React.useState([
    ...Array(paginationLength).keys(),
  ]);
  React.useEffect(() => {
    setCount(countValue || 1);
  }, [countValue]);
  React.useEffect(() => {
    handleScrollToEvent();
  }, []);
  // To handle next and previous button of pagination
  const handleClick = (type, value) => {
    if (type === 'next') {
      dispatch(setPaginationIndex(count + 1));
    }

    if (type === 'previous') {
      dispatch(setPaginationIndex(count - 1));
    }

    if (type === 'change') {
      if (value < 1 || value > paginationArray.length) {
        dispatch(setPaginationIndex(paginationArray.length));
      } else {
        dispatch(setPaginationIndex(value));
      }
    }
  };

  // TO handle any changes in the pagination text field
  const handleBlur = (value) => {
    const numericValue = parseInt(value);
    let correctedValue = 1;
    if (isNaN(numericValue) || value === '' || numericValue < 1) {
      dispatch(setPaginationIndex(1));
    } else if (numericValue > paginationArray.length) {
      dispatch(setPaginationIndex(paginationArray.length));
      correctedValue = paginationArray.length;
    } else {
      dispatch(setPaginationIndex(numericValue));
      correctedValue = numericValue;
    }
      return correctedValue;
  };

  // handling full screen view
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  // mfg grid api
  // let manufacturer = manufactureID?.find(
  //   (item) => item.manufacturerName === manufactureName[count - 1]
  // )?.manufacturerID;
  const sortedData = manufactureID?.sort(
    (a, b) => a.manufacturerID - b.manufacturerID
  );
  const manuID = sortedData[count - 1]?.manufacturerID || '';
  const manuName = sortedData[count - 1]?.manufacturerName || '';
  React.useEffect(() => {
    setMfgGrid(mfgGridList?.rebateDisputeActivityGridNdcVO);
  }, [mfgGridList]);
  React.useEffect(() => {
    if (getSelectedOptionList === 'Manufacturer' && getDisputeCode && manuID)
      dispatch(
        getMFGGrid(
          {
            rebateProgramCD: getRebateProgramName?.rebateProgramCd,
            mfgId: [manuID],
            disputeCode: getDisputeCode,
            openStatus: checkboxValues.open ? 1 : 0,
            closeStatus: checkboxValues.closed ? 1 : 0,
          },
          true
        )
      );
  }, [count, checkboxValues]);
  // ndc grid api
  React.useEffect(() => {
    setNdcGrid(ndcGridList?.rebateDisputeActivityGridNdcVO);
  }, [ndcGridList]);

  React.useEffect(() => {
    if (
      getSelectedOptionList === 'NDC' &&
      drugDataList[count - 1]?.drugSeqNum
    ) {
      dispatch(
        getNDCGrid({
          rebateProgramCD: getRebateProgramName?.rebateProgramCd,
          drugSeqNum: [drugDataList[count - 1]?.drugSeqNum],
          disputeCode: getDisputeCode,
          openStatus: checkboxValues.open ? 1 : 0,
          closeStatus: checkboxValues.closed ? 1 : 0,
        })
      );
    }
  }, [count, checkboxValues]);
  const [exportFileName, setExportFileName] = React.useState(null);
  const exportAllTpPDF = (name) => {
    setExportFileName(name);
    setIsExportAllClick(true);
    if (getSelectedOptionList === 'Manufacturer') {
      dispatch(
        getMFGGridExportAll(
          {
            rebateProgramCD: getRebateProgramName?.rebateProgramCd,
            mfgId: manuID,
            disputeCode: getDisputeCode,
            openStatus: checkboxValues.open ? 1 : 0,
            closeStatus: checkboxValues.closed ? 1 : 0,
          },
          manufactureID
        )
      );
    }
    if (getSelectedOptionList == 'NDC') {
      dispatch(
        getNDCGridExportAll(
          {
            rebateProgramCD: getRebateProgramName?.rebateProgramCd,
            drugSeqNum: [],
            // drugSeqNum: [drugDataList[count - 1]?.drugSeqNum],
            disputeCode: getDisputeCode,
            openStatus: checkboxValues.open ? 1 : 0,
            closeStatus: checkboxValues.closed ? 1 : 0,
          },
          drugDataList
        )
      );
    }
  };
  const onGridReady = (params) => {
    setColumnApi(params.columnApi);
  };
  const addPinnedRowData = (exportAllData) => {
    const exportAllDataObj = {};
    for (const key in exportAllData) {
      const data = exportAllData[key];
      const pinnedRow = {
        ndc: 'Total',
        disputeUnitsRebateAmount: 0,
        bold: true,
      };
      for (let i = 0; i < data.length; i += 1) {
        pinnedRow.disputeUnitsRebateAmount += data[i].disputeUnitsRebateAmount;
      }
      data.push(pinnedRow);
      exportAllDataObj[key] = data;
    }

    return exportAllDataObj;
  };
  React.useEffect(() => {
    if (isExportAllClick && exportAllData != undefined) {
      if (Object.keys(exportAllData).length === 4) {
        setIsExportAllClick(false);

        let data = [];
        for (const key in exportAllData) {
          if (Array.isArray(exportAllData[key])) {
            data = [...data, ...exportAllData[key]];
          }
        }

        if (data?.length > 0) {
          const groupedData =
            getSelectedOptionList == 'NDC'
              ? groupBy(data, 'drugSeqNum')
              : groupBy(data, 'mfgId');

          // Sort 
          Object.keys(groupedData).forEach((key) => {
            groupedData[key].sort((a, b) => {
              // Primary sort NDC
              const aNdc = a.ndc || String(a.drugSeqNum || '');
              const bNdc = b.ndc || String(b.drugSeqNum || '');
              if (aNdc !== bNdc) {
                return String(aNdc).localeCompare(String(bNdc), undefined, {
                  numeric: true,
                  sensitivity: 'base',
                });
              }

              // Secondary sort qtr
              const aQtr = a.quarter || a.qtr || '';
              const bQtr = b.quarter || b.qtr || '';
              if (!aQtr && !bQtr) return 0;
              if (!aQtr) return -1;
              if (!bQtr) return 1;
              return comparatorQtrNew(aQtr, bQtr);
            });
          });

          const header = {
            reportName: 'Dispute Activity Report',
            fileName: exportFileName ? exportFileName : 'UnitAdjAtNDCLvl',
          };
          const mapping = {};

          if (getSelectedOptionList == 'Manufacturer') {
            for (let i = 0; i < manufactureID.length; i += 1) {
              mapping[
                manufactureID[i].manufacturerID
              ] = `${manufactureID[i].manufacturerName} (${manufactureID[i].manufacturerID})`;
            }
          }
          if (getSelectedOptionList == 'NDC') {
            for (let i = 0; i < drugDataList.length; i += 1) {
              mapping[
                drugDataList[i].drugSeqNum
              ] = `${drugDataList[i].drugName} (${drugDataList[i].drugSeqNum})`;
            }
          }
          const options = {
            info: { thirdInfo, fourthInfo },
            titleName:
              getSelectedOptionList == 'NDC'
                ? 'Drug Name: '
                : 'Manufacture Name: ',
            pageSize: {
              height: 800,
              width: 2000,
            },
            mapping,
          };
          let paginationArr = [];
          if (getSelectedOptionList == 'Manufacturer') {
            paginationArr = manufactureID
              ? manufactureID.map((m) => String(m.manufacturerID))
              : Object.keys(groupedData);
            paginationArr.sort();
          } else if (getSelectedOptionList == 'NDC') {
            paginationArr = drugDataList
              ? drugDataList.map((d) => String(d.drugSeqNum))
              : Object.keys(groupedData);
          } else {
            paginationArr = Object.keys(groupedData);
          }
          const widths = [];
          let allData = addPinnedRowData(groupedData);
       
          if (Array.isArray(paginationArr) && paginationArr.length > 0) {
            paginationArr.forEach((key) => {
              const k = String(key);
              if (!allData.hasOwnProperty(k)) {
                allData[k] = [
                  {
                    ndc: 'Total',
                    disputeUnitsRebateAmount: 0,
                    bold: true,
                  },
                ];
              }
            });
          }
          const exportOptions = { ...options, totalPages: paginationArr.length };
          exportAllPDF(
            header,
            allData,
            columnApi,
            userDefaults,
            exportOptions,
            paginationArr,
            widths,
            logInUser
          );
        } else {
          setError([NO_DATA]);
        }
      }
    }
  }, [exportAllData]);

  // manufacture ID
  const mID =
    getSelectedOptionList === 'NDC'
      ? drugDataList[count - 1]?.labelerCode
      : [manuID];
  // manufacturer Name
  let mName = getSelectedOptionList !== 'NDC' ? manuName : '';
  if (getSelectedOptionList === 'NDC') {
    if (ndcGrid?.length > 0) {
      mName = ndcGrid?.find((item) => {
        return item.mfgId === mID;
      })?.mfgName;
    } else {
      mName = labelerSelectedRow?.labelerName;
    }
  }

  // pinned row

  const [filterApply, setFilterApply] = React.useState(false);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };

  const sum = (property) => {
    const displayedRows = filterApply
      ? filteredRows
      : getSelectedOptionList == 'NDC'
      ? ndcGrid
      : mfgGrid;
    if (property === 'checkLogNum') {
      const data = displayedRows.length;
      return `${data} Checks`;
    }
    const data = displayedRows?.reduce((accumulator, object) => {
      return (
        accumulator + (object[property] ? parseFloat(object[property]) : null)
      );
    }, 0);
    return data ? parseFloat(data).toFixed(2) : '0.00';
  };
  const createData = (count, prefix) => {
    const result = [];
    for (let i = 0; i < count; i += 1) {
      result.push({
        isBottomRow: true,
        dispute_cd: 'Total Balance Due',
        disputeUnitsRebateAmount: sum('disputeUnitsRebateAmount'),
      });
    }
    return result;
  };
  const pinnedBottomRowData = useMemo(() => {
    return createData(1, 'Bottom');
  }, [mfgGrid, ndcGrid, filteredRows, filterApply]);
  const onFilterChanged = (rowData, type) => {
    const updatedRowData = rowData.map((item) => {
      return {
        ...item,
        // disputeUnitsRebateAmount: parseFloat(
        //   item.disputeUnitsRebateAmount?.replace('$', '').replace(/,/g, '')
        // ),
      };
    });
    setFilteredRow(updatedRowData);
  };
  // pdf header
  let firstInfo = '';
  let secondInfo = '';
  let thirdInfo = '';
  let fourthInfo = '';
  firstInfo = `Manufacturer ID : ${mID}`;
  secondInfo = `Manufacturer Name: ${mName}`;
  thirdInfo = `${`${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`}`;
  fourthInfo = `Dispute : ${getDisputeCode}`;

  return (
    <div className="tabs-contaitBillPanel custom-check tabs-container">
      <Spinner load={spinnerLoader} />
      <DisplayErrorMessages errorMessages={error.map((l) => l)} />
      <CustomSeparator
        parent1="Summary Reports"
        parent2="Display Dispute Activity"
      />
      {!fullScreenView && (
        <>
          <div className="row mb-5">
            <div className="col-12">
              <PaginationBox
                array={paginationArray}
                count={count}
                handleClick={handleClick}
                handleBlur={handleBlur}
              />
            </div>
          </div>
          <div className="panel custom-fieldset">
            <div className="custom-check">
              <div className="form-wrapper">
                <div className="mui-custom-form input-md">
                  <div className="col-12">
                    <TextField
                      label="Manufacturer ID : "
                      id="Manufacturer ID : "
                      fullWidth
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      name="Manufacturer ID"
                      value={mID}
                      disabled
                    />
                  </div>
                </div>
                <div className="mui-custom-form input-md">
                  <div className="col-12">
                    <TextField
                      label="Manufacturer Name "
                      id="Manufacturer Name"
                      fullWidth
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      name="Manufacturer Name "
                      disabled
                      value={mName}
                    />
                  </div>
                </div>
                <div className="mui-custom-form input-md">
                  <div className="col-12">
                    <TextField
                      id="Rebate_Program"
                      label="Rebate Program"
                      fullWidth
                      placeholder=""
                      inputProps={{ id: 'Rebate_Program' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={`${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`}
                      disabled
                    />
                  </div>
                </div>
                <div className="mui-custom-form input-md">
                  <div className="col-12">
                    <TextField
                      id="Dispute_Code"
                      label="Dispute Code"
                      fullWidth
                      placeholder=""
                      inputProps={{ id: 'Dispute_Code' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={getDisputeCode}
                      disabled
                    />
                  </div>
                </div>
                <div
                  className="col-4 frr-two-col-radio"
                  style={{ marginTop: '10px' }}
                >
                  <fieldset className="custom-fieldset">
                    <legend className="same-font-family">Status</legend>
                    <div className="form-wrapper p-2">
                      <div className="mui-custom-form with-select field-xl no-lbl">
                        <RadioGroup row name="report-quarter" required>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={checkboxValues.open}
                                color="primary"
                                name="open"
                                onChange={(e) => {
                                  let value = {
                                    ...checkboxValues,
                                    open: !checkboxValues.open,
                                  };
                                  if (
                                    checkboxValues.open &&
                                    !checkboxValues.closed
                                  )
                                    value = {
                                      ...value,
                                      closed: !checkboxValues.closed,
                                    };
                                  dispatch(dispatchStatus(value));
                                  setCheckboxValues(value);
                                }}
                              />
                            }
                            label="Open"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={checkboxValues.closed}
                                color="primary"
                                name="closed"
                                onChange={(e) => {
                                  let value = {
                                    ...checkboxValues,
                                    closed: !checkboxValues.closed,
                                  };
                                  if (
                                    !checkboxValues.open &&
                                    checkboxValues.closed
                                  )
                                    value = {
                                      ...value,
                                      open: !checkboxValues.open,
                                    };
                                  dispatch(dispatchStatus(value));
                                  setCheckboxValues(value);
                                }}
                              />
                            }
                            label="Closed"
                          />
                        </RadioGroup>
                      </div>
                    </div>
                  </fieldset>
                </div>
                {getSelectedOptionList == 'NDC' && (
                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        id="NDC_Code"
                        label="NDC"
                        fullWidth
                        placeholder=""
                        inputProps={{ id: 'NDC_Code' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={`${drugDataList[count - 1]?.labelerCode}-${
                          drugDataList[count - 1]?.productCode
                        }-${drugDataList[count - 1]?.packageSize}`}
                        disabled
                      />
                    </div>
                  </div>
                )}
                {getSelectedOptionList == 'NDC' && (
                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        id="Drug_Name"
                        label="Drug Name"
                        fullWidth
                        placeholder=""
                        inputProps={{ id: 'Drug_Name' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={drugDataList[count - 1]?.drugName}
                        disabled
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}

      <div className="panel-body FRR-custom-table tbl-manufacturer-inner bottom-pinned-bold">
        {' '}
        <TableGrid
          data-testid="onEditingStopped"
          gridCall={onGridReady}
          fullScreenView={fullScreenView}
          handleFullScreenViewClick={handleFullScreenView}
          rowSelection="single"
          countValue={count}
          rowMultiSelectWithClick={false}
          columnDefs={AllManufactureTableHead}
          noGlobalSort
          rowData={
            getSelectedOptionList == 'NDC'
              ? ndcGrid?.map((item) => {
                  return {
                    ...item,
                    disputeUnitsRebateAmount: item.disputeUnitsRebateAmount
                      ? parseFloat(item.disputeUnitsRebateAmount)?.toFixed(2)
                      : '0.00',
                  };
                })
              : mfgGrid?.map((item) => {
                  return {
                    ...item,

                    disputeUnitsRebateAmount: item.disputeUnitsRebateAmount
                      ? parseFloat(item.disputeUnitsRebateAmount)?.toFixed(2)
                      : '0.00',
                  };
                })
          }
          defaultCol={{
            wrapHeaderText: true,
            autoHeaderHeight: true,
          }}
          gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
          exportFile
          animateRows
          sideBar={false}
          fileName="UnitAdjAtNDCLvl"
          reportName="Dispute Activity Report"
          isScrollOn
          singleClickEdit
          navigateToNextCell={navigateToNextCell}
          tabToNextCell={tabToNextCell}
          enterMovesDown
          suppressCellFocus
          onFilterData={onFilterChanged}
          onCellFocused={onCellFocused}
          pinnedBottomRowData={pinnedBottomRowData}
          info={{ firstInfo, secondInfo, thirdInfo, fourthInfo }}
          exportAllTpPDF={paginationLength > 1 ? exportAllTpPDF : null}
          frameworkComponents={{
            TextBoxRender: (cellInfo) => {
              const name = cellInfo?.value;
              if (name && name.length > 20) {
                return (
                  <OverlayTrigger
                    placement="bottom"
                    overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                  >
                    <div>{name}</div>
                  </OverlayTrigger>
                );
              }
              return <div>{name}</div>;
            },
          }}
          getFilterApply={getFilterApply}
        />{' '}
      </div>
    </div>
  );
};
export default DisplayDisputeActivity;
